<template>
  <div class="pg-upload-card">
    <Upload
      :drag="drag"
      list-type="picture-card"
      :auto-upload="true"
      :action="actionUrl"
      :data="param"
      :headers="headers"
      :multiple="multiple"
      :file-list="fileList"
      :limit="limit"
      :before-upload="onBeforeUpload"
      :on-success="onSuccess"
      :on-error="onError"
      :on-exceed="onExceed"
      :disabled="disabled"
    >
      <template #default>
        <slot name="default">
          <i class="el-icon-plus"></i>
        </slot>
      </template>
      <template #file="{ file }">
        <slot name="file" :file="file">
          <div>
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <span class="el-upload-list__item-actions">
              <!-- <span class="el-upload-list__item-preview" @click="preview(file)">
                <i class="el-icon-zoom-in"></i>
              </span> -->
              <!-- <span v-if="!disabled" class="el-upload-list__item-delete" @click="download(file)">
                <i class="el-icon-download"></i>
              </span> -->
              <span v-if="!disabled" class="el-upload-list__item-delete" @click="remove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </slot>
      </template>
    </Upload>
    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import { ref, computed } from 'vue'
import { Upload } from 'element-ui'
import { useUpload, useUploadCard } from '../hooks/index'

const emit = defineEmits(['input'])

const props = defineProps({
  value: { type: [String, Array] },
  action: { type: String, default: 'rest/ezcomp/file/uploadFile' },
  actionParam: {
    type: Object,
    default() {
      return {}
    },
  },
  catalogCode: { type: String, default: 'ORDER_INFO' },
  drag: Boolean,
  disabled: { type: Boolean, default: false },
  multiple: { type: Boolean, default: false },
  valueIsObj: { type: Boolean, default: false },
  limit: { type: Number },
  maxSize: { type: Number, default: 2 * 1024 * 1000 }, // 2M = 2 * 1024 * 1000
  format: {
    type: Array,
    default: function () {
      return ['jpg', 'jpeg', 'png', 'bmp', 'gif']
    },
  },
})

const param = computed(() => {
  const tmp = { ...props.actionParam }
  if (props.catalogCode) tmp.catalogCode = props.catalogCode

  return tmp
})

const getList = (val) => {
  if (!val) return []
  if (props.valueIsObj) {
    return val
  } else {
    let tempVal = props.multiple ? (Array.isArray(val) ? val : val.split(',')) : [val]
    return tempVal.map((item) => {
      const tmp = item.split('/')
      const len = tmp.length

      const name = tmp[len - 1]
      return { url: item, name }
    })
  }
}

const fileList = ref(getList(props.value))

const { actionUrl, headers, onBeforeUpload, onSuccess, onError, onExceed } = useUpload({
  fileList,
  props,
  emit,
})
const { remove } = useUploadCard({ fileList, props, emit })
</script>
<style lang="scss">
@import '../style/upload-card.scss';
</style>
